import { createI18n } from 'vue-i18n';
import { missingKeyHandler } from './missing-handler';
import {
  FALLBACK_LOCALE,
  FALLBACK_LOCALES,
  LOCALE_MESSAGES,
} from './supported-locales';
import type { LocaleCode, LocaleMessageSchema } from './types';

export const i18n = createI18n<false>({
  legacy: false,
  // Enables `this.$t` / `this.$te` in options-API components.
  globalInjection: true,
  locale: FALLBACK_LOCALE,
  fallbackLocale: FALLBACK_LOCALES,
  // vue-i18n types every locale as the full schema; pt-BR leaves the keys it
  // lacks to FALLBACK_LOCALES.
  messages: LOCALE_MESSAGES as Record<LocaleCode, LocaleMessageSchema>,
  missing: missingKeyHandler,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  // Keep missing-key reporting opt-in through our own handler (above), not
  // through console warnings.
  missingWarn: false,
  fallbackWarn: false,
});
